export default __webpack_public_path__ + "fca954f7310985fe99e6082a4147153d.pdf";